import React, { useState, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handlePutRequest } from "../../../services/PutTemplate";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { v4 as uuidv4 } from 'uuid';

const AddEditModule = ({ onHide, editable, moduleRowData, getModule }) => {

    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const moduleId = moduleRowData.moduleId;

    useEffect(() => {
        if (moduleRowData !== undefined || moduleRowData !== null) {
            formik.setFieldValue("moduleName", moduleRowData.moduleName);
            formik.setFieldValue("moduleCode", moduleRowData.moduleCode);
        }
    }, [moduleRowData]);

    useEffect(() => {
        if (!editable) {
            formik.resetForm();
        }
    }, [editable]);

    const validationSchema = Yup.object().shape({
        moduleName: Yup.string().required("This field is required."),
        // moduleCode: Yup.string().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            moduleName: "",
            // moduleCode: "",
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");

            try {
                const uuId = uuidv4()
                const uniqueId = uuId.split("-")
                data["moduleId"] = moduleId;

                if (editable === true) {
                    await handlePutRequest(data, `zbizgateway/nonFin/updateModule/`);
                } else {
                    data["moduleCode"] = formik.values.moduleName + "_" + uniqueId[4];
                    await handlePostRequest(data, "zbizgateway/nonFin/saveModule");
                }

                await getModule();
                onHide();
            } catch (error) {
                console.error("An error occurred:", error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
                formik.resetForm();
                console.log("here");
            }
        },

    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card dialog_card">

                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-field input_cp">
                        <label htmlFor="moduleName" className={classNames({ "p-error": isFormFieldValid("moduleName") }, "Label__Text")}>
                            Module Name<span className="Label__Required">*</span>
                        </label>
                        <InputTextarea
                            placeholder="Add Description"
                            id="moduleName"
                            name="moduleName"
                            value={formik?.values?.moduleName?.replace(/\s\s+/g, " ")}
                            rows={5}
                            cols={10}
                            onChange={formik.handleChange}
                            className={classNames({ "p-invalid": isFormFieldValid("moduleName") }, "input_text")}
                        />
                        {getFormErrorMessage("moduleName")}
                    </div>
                    {/* <div className="p-field p-col-12 p-md-12">
                        <div className="p-field">
                            <label htmlFor="moduleCode" className={classNames({ "p-error": isFormFieldValid("moduleCode") }, "Label__Text")}>
                                Code<span className="Label__Required">*</span>
                            </label>
                            <InputText placeholder="Enter Code for Role" id="moduleCode" name="moduleCode" value={formik?.values?.moduleCode?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("moduleCode") }, "Input__Round")} />

                            {getFormErrorMessage("moduleCode")}
                        </div>
                    </div> */}
                    <div className="Top__Btn">
                        <Button disabled={loading} label={editable ? "Update" : "Add"} className="Add_New" />
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddEditModule;
